/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const d=r=>r.sort((a,t)=>a.date.getTime()-t.date.getTime()),o=r=>{let e;return r.reduce((t,s)=>(e!==s.date.getFullYear()?(e=s.date.getFullYear(),t.push({yearFlag:e},s)):t.push(s),t),[])};exports.addYearsFlags=o;exports.sortEventList=d;
